import { render, staticRenderFns } from "./UserRolePicker.vue?vue&type=template&id=37931b37"
import script from "./UserRolePicker.vue?vue&type=script&lang=js"
export * from "./UserRolePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports